/*
 * @Description:
 * @Date: 2024-12-05 13:39:33
 */
import qs from 'qs';

interface nativeMethod {
  kernel: 'flutter' | 'xcx' | 'wx' | 'ios' | 'pc' | '' | 'android';
  platform: 'flutter' | 'ios' | 'pc' | '' | 'android';
  phoneModel: string;
  userAgent: string;
  AppVersion: string | number;
  token: string;
  method: {
    /**
     * @description: 关闭页面
     */
    close: (params?: any) => void;
    /**
     * @description: 实名认证完成
     */
    authenticationDone: (params?: any) => void;
    /**
     * @description: 人脸识别认证成功
     * @param :token 认证成功后返回的token
     */
    faceAuthComplete: (params: any) => void;
    /**
     * @description: 人脸识别认证失败
     * @param :tmName 失败返回tmName
     */
    faceAuthFile: (params: any) => void;
    /**
     * @description: 合同签署完成
     */
    contractSignDone: () => void;
    /**
     * @description: 个税授权完成
     */
    taxAuthDone: () => void;
    /**
     * @description: 登录人脸识别完成
     */
    faceAuthLoginComplete: (params: any) => void;
    /**
     * @description: 提现人脸识别完成
     */
    faceAuthWithdrawComplete: (params: any) => void;
    /**
     * @description: 收款确认单
     */
    walletConfirmDone: (params?: any) => void;
    /**
     * @description: 跳转其他webview
     */
    toOtherWebview?: (params?: any) => void;
  };
  user: {
    userId?: string | number | string[] | qs.ParsedQs | qs.ParsedQs[];
    token?: string;
  };
}

class nativeMethod {
  constructor() {
    this.kernel = ''; // 当前宿主
    this.platform = ''; // 当前平台 flutter(安卓和苹果公用，调试时需要区分看phoneModel) ios pc
    this.method = null;
    this.user = {};
    this.userAgent = '';
    this.AppVersion = '';
    this.phoneModel = '';
    this.token = '';
    this.init();
  }
  async init() {
    await this.getUserAgent();
    await this.currentKernel();
    await this.setMethod();
  }
  // 获取userAgent
  async getUserAgent() {
    if (this.AppVersion) {
      return;
    }
    const t = navigator.userAgent.split('YiXueZhuShouLianMeng?');
    if (t.length > 1) {
      const query = qs.parse(t[1]);
      this.userAgent = t[1];
      this.AppVersion = query.AppVersion
        ? Number(`${query.AppVersion}`.replace(/\./g, ''))
        : '';
      this.token = `${query.token}`;
      this.phoneModel = `${query.PhoneModel}`;
      // alert(JSON.stringify(query));
      console.warn('userAgent.token', query.token);
      // try {
      //   useUserStoreSetup().setInfo({
      //     token: this.token,
      //     userId: query.userId as string
      //   });
      // } catch (error) {
      //   console.warn('设置本地token失败', error);
      // }
      this.user = {
        userId: query.userId,
        token: this.token
      };
    } else {
      console.warn('userAgent中没有YiXueZhuShouLianMeng字段');
    }
  }
  // 当前宿主环境
  async currentKernel() {
    if (this.kernel) {
      return this.kernel;
    }
    const ua = navigator.userAgent.toLowerCase();
    // 判断平台
    if (/flutter/.test(ua)) {
      this.platform = 'flutter';
    } else if (/android/.test(ua)) {
      this.platform = 'android';
    } else if (/iphone|ipad|ipod/.test(ua)) {
      this.platform = 'ios';
    } else {
      this.platform = 'pc';
    }
    // 判断宿主
    if (/miniprogram/.test(ua)) {
      this.kernel = 'xcx';
    } else if (/micromessenger/.test(ua)) {
      this.kernel = 'wx';
    } else if (/android/.test(ua)) {
      this.kernel = 'android';
    } else {
      if (/flutter/.test(ua)) {
        this.kernel = 'flutter';
      } else if (/iphone|ipad|ipod/.test(ua)) {
        this.kernel = 'ios';
      } else {
        this.kernel = 'pc';
      }
    }
  }
  /**
   * @description: 兼容公共方法 xcx  flutter ios
   * @param {string} ken 内核标识
   */
  setMethod() {
    if (this.method) {
      return Promise.resolve(this.method);
    }
    if (this.kernel === 'xcx') {
      const miniProgram = Reflect.get(window, 'wx')?.miniProgram;
      this.method = {
        close: () => miniProgram?.navigateBack?.(),
        authenticationDone: type => {
          miniProgram?.redirectTo?.({
            url: '/views-c/auth/src/views/auth-result/auth-result?type=' + type
          });
        },
        faceAuthComplete: (params = {}) => {
          miniProgram?.redirectTo?.({
            url: `/views/login/src/views/login-set-phone/login-set-phone?preStepResult=${params.token}&phone=${params.phone}&isUseOldPhone=0&source=face`
          });
        },
        faceAuthLoginComplete: (params = {}) => {
          miniProgram?.postMessage({
            data: params
          });
          miniProgram?.navigateBack?.();
        },
        faceAuthWithdrawComplete: (params = {}) => {
          miniProgram?.redirectTo?.({
            url: `/views-b/wallet/src/views/wallet-withdraw-result/wallet-withdraw-result?id=${params.outId}&from=face`
          });
        },
        faceAuthFile: (params = {}) => {
          miniProgram?.redirectTo?.({
            url: `/views-d/person/src/views/person-auth-face-fail/person-auth-face-fail?${Object.keys(
              params
            )
              .map(key => `${key}=${params[key]}`)
              .join('&')}`
          });
        },
        contractSignDone: () => {
          miniProgram?.redirectTo?.({
            url: `/views-c/contract/src/views/contract-redirect/contract-redirect`
          });
        },
        taxAuthDone: () => {
          miniProgram?.redirectTo?.({
            url: `/views-c/incomeAuth/src/views/auth-confirm/auth-confirm`
          });
        },
        walletConfirmDone: () => {
          miniProgram?.redirectTo?.({
            url: '/views-b/wallet/src/views/wallet-redirect/wallet-redirect'
          });
        },
        toOtherWebview: (url: string) => {
          miniProgram?.redirectTo?.({
            url: `/views/webview/src/views/webview-common?url=${encodeURIComponent(
              url
            )}`
          });
        }
      };
    } else if (this.kernel === 'ios' && Reflect.get(window, 'webkit')) {
      const native = Reflect.get(window, 'webkit').messageHandlers.native;
      this.method = {
        close: query => {
          native.postMessage({
            close: query
          });
        },
        walletConfirmDone: query => {
          native.postMessage({
            close: query
          });
        },
        authenticationDone: type => {
          native.postMessage({
            push: {
              url: 'realNameAuthResultPage',
              query: {
                type
              }
            }
          });
        },
        faceAuthComplete: (query = {}) => {
          native.postMessage({
            push: {
              url: 'updatePhone',
              query
            }
          });
        },
        faceAuthFile: (query = {}) => {
          native.postMessage({
            push: {
              url: 'faceAuthFailed',
              query
            }
          });
        },
        faceAuthLoginComplete: (query = {}) => {
          native.postMessage({
            push: {
              url: 'loginFaceAuthPage',
              query
            }
          });
        },
        faceAuthWithdrawComplete: (query = {}) => {
          native.postMessage({
            push: {
              url: 'withdrawFaceAuthPage',
              query
            }
          });
        },
        contractSignDone: (query = {}) => {
          native.postMessage({
            push: {
              url: 'signContractSuccess',
              query
            }
          });
        },
        taxAuthDone: (query = {}) => {
          native.postMessage({
            push: {
              url: 'recyclingAuth',
              query
            }
          });
        }
      };
    } else if (
      this.kernel === 'flutter' &&
      Reflect.get(window, 'flutter_inappwebview')
    ) {
      const native = Reflect.get(window, 'flutter_inappwebview');
      this.method = {
        close: (query = {}) => native.callHandler('close', query),
        walletConfirmDone: (query = {}) => native.callHandler('close', query),
        authenticationDone: type => {
          native.callHandler('push', {
            url: 'realNameAuthResultPage',
            query: {
              type
            }
          });
        },
        faceAuthComplete: (query = {}) => {
          native.callHandler('push', {
            url: 'changePhonePage',
            query
          });
        },
        faceAuthFile: (query = {}) => {
          native.callHandler('push', {
            url: 'faceAuthFailPage',
            query
          });
        },
        contractSignDone: (query = {}) => native.callHandler('close', query),
        taxAuthDone: (query = {}) =>
          native.callHandler('push', {
            url: 'syAuthorizePage',
            query
          }),
        faceAuthLoginComplete: (query = {}) =>
          native.callHandler('push', {
            url: 'loginFaceAuthPage',
            query
          }),
        faceAuthWithdrawComplete: (query = {}) =>
          native.callHandler('push', {
            url: 'withdrawFaceAuthPage',
            query
          })
      };
    } else if (
      this.kernel === 'android' &&
      Reflect.get(window, 'flutter_inappwebview')
    ) {
      const native = Reflect.get(window, 'flutter_inappwebview');

      const queryToString = query => {
        return JSON.stringify(query);
      };

      this.method = {
        close: (query = {}) =>
          native.callHandler('close', queryToString(query)),
        walletConfirmDone: (query = {}) =>
          native.callHandler('close', queryToString(query)),
        authenticationDone: type => {
          native.callHandler(
            'push',
            queryToString({
              url: 'realNameAuthResultPage',
              query: { type }
            })
          );
        },
        faceAuthComplete: (query = {}) => {
          native.callHandler(
            'push',
            queryToString({
              url: 'changePhonePage',
              query
            })
          );
        },
        faceAuthFile: (query = {}) => {
          native.callHandler(
            'push',
            queryToString({
              url: 'faceAuthFailPage',
              query
            })
          );
        },
        contractSignDone: (query = {}) => {
          native.callHandler('close', queryToString(query));
        },
        taxAuthDone: (query = {}) => {
          native.callHandler(
            'push',
            queryToString({
              url: 'syAuthorizePage',
              query
            })
          );
        },
        faceAuthLoginComplete: (query = {}) =>
          native.callHandler(
            'push',
            queryToString({
              url: 'loginFaceAuthPage',
              query
            })
          ),
        faceAuthWithdrawComplete: (query = {}) =>
          native.callHandler(
            'push',
            queryToString({
              url: 'withdrawFaceAuthPage',
              query
            })
          )
      };
    }
  }
}
export default new nativeMethod();
